import { resetIsContextMenuOpenForLinks, setIsContextMenuOpen } from '../actions/internalActions';
import getComposeLinkViewState from '../selectors/getComposeLinkViewState';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
mutator(setIsContextMenuOpen, function (actionMessage) {
    var composeLinkViewState = getComposeLinkViewState(actionMessage.linkId);
    composeLinkViewState.isContextMenuOpen = actionMessage.value;
});
mutator(resetIsContextMenuOpenForLinks, function (actionMessage) {
    var store = getStore();
    store.composeLinks.forEach(function (link) { return (link.isContextMenuOpen = false); });
});
//# sourceMappingURL=isContextMenuOpenMutators.js.map